import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {
  amount: "",
  carrierId: "",
  quoteToken: "",
};
 
const authSlice = createSlice({
  name: "amount",
  initialState,
  reducers: {
    setRechargeAmount: (state, action) => {
      state.amount = action.payload;
    },
    setRechargeCarrierId: (state, action) => {
      state.carrierId = action.payload;
    },
    setRechargeQuoteToken: (state, action) => {
      state.quoteToken = action.payload;
    },
    resetPaymentState: (state) => {
      Object.assign(state, initialState);
    }, 
  },
 
});
 
export const { setRechargeAmount, setRechargeCarrierId, setRechargeQuoteToken, resetPaymentState } = authSlice.actions;
export default authSlice.reducer;